module.exports = __webpack_public_path__ + "static/media/guest_services.e1858850.svg";